import React, {useEffect,useRef} from 'react';
import { Helmet } from "react-helmet";

import Advert from '../App/Advert/Advert'

import classes from './FoodCalculator.scss';

function FoodCalculator(props) {

    let foodCalculatorContent = useRef()

    useEffect(() => {
        
        window.addEventListener("message",(e) => {
            console.log("GOT A MESSAGE!", e.data)
            if (e.data.hasOwnProperty("frameHeight")) {
                if(e.data.frameHeight == 0){
                    foodCalculatorContent.current.style.height = "100vh"
                }else{
                    console.log("Current iframe height ", foodCalculatorContent.current.style.height, "Next iframe height ", e.data.frameHeight)
                    foodCalculatorContent.current.style.height = `${e.data.frameHeight}px`;
                }
            }
        });

    },[])
    return (
        <div className={'FoodCalculator'}>
            <Helmet
                title={"Follow the Food | BBC Future"}
                link={
                    [
                        {
                            rel:"canonical",
                            href:"https://www.bbc.com"+process.env.PUBLIC_URL+"/calculate-the-environmental-footprint-of-your-food.html"
                        }
                    ]
                }
                meta={
                    [
                        {
                            name: "description",
                            content: "How does your diet impact the environment? Calculate the carbon footprint produced by your favourite food and drink."
                        },
                        {
                            name: "twitter:card",
                            content: "summary_large_image"
                        },
                        {
                            name: "twitter:image:src",
                            content: "https://www.bbc.com"+process.env.PUBLIC_URL+"/foodcalculator/img/featured-img.jpg"
                        },
                        {
                            name: "twitter:title",
                            content: "Calculate the ‘foodprint’ of what you eat"
                        },
                        {
                            name: "twitter:description",
                            content: "How does your diet impact the environment? Calculate the carbon footprint produced by your favourite food and drink: https://www.bbc.comfuture/bespoke/follow-the-food/calculate-the-environmental-footprint-of-your-food.html via @BBC_Future"
                        },
                        {
                            name: "og:title",
                            content: "Calculate the ‘foodprint’ of what you eat"
                        },
                        {
                            name: "og:type",
                            content: "website"
                        },
                        {
                            name: "og:url",
                            content: "https://www.bbc.com"+process.env.PUBLIC_URL+"/calculate-the-environmental-footprint-of-your-food.html"
                        },
                        {
                            name: "og:image",
                            content: "https://www.bbc.com"+process.env.PUBLIC_URL+"/foodcalculator/img/featured-img.jpg"
                        },
                        {
                            name: "og:description",
                            content: "How does your diet impact the environment? Calculate the carbon footprint produced by your favourite food and drink."
                        },
                        {
                            name: "og:site_name",
                            content: "BBC Future"
                        }
                    ]

                }
            >

            </Helmet>
            <Advert windowSize={props.windowSize}/>
            <iframe className={'FoodCalculator__iframe'} ref={foodCalculatorContent} scrolling="no" src={`${process.env.PUBLIC_URL}/foodcalculator/index.html`}></iframe>

        </div>
    )

}

export default FoodCalculator;